import PropTypes from 'prop-types';

export const props = {
  faqs: PropTypes.array,
  conditions: PropTypes.array,
  highlightColor: PropTypes.string,
  modernImage: PropTypes.string,
};
